import { FootchinkoItem } from "./FootchinkoItem";
import { GameConstants } from "../../GameConstants";

export class CactusPeg extends FootchinkoItem {

    constructor(game: Phaser.Game, x: number, y: number) {

        super(game, x, y, "texture_atlas_1", true);

        this.canBeHit = false;
    }

    public setBody(): void {

        this.body.setCircle(30);
        this.body.static = true;
    }

    public setView(): void {

        this.name = GameConstants.CACTUS_PEG;
        this.burntFrameName = "burnt-peg";
        this.frameName = "pin_elec_0001";

        this.anchor.setTo(.5);

        this.animations.add("irradiate", Phaser.Animation.generateFrameNames("pin_elec_", 1, 3, "", 4), 12, true);

        // para desacompasarlos
        this.game.time.events.add(Math.random() * 500, function (): void {
            this.animations.play("irradiate");
        }, this);
    }

    public burn(): void {

        this.animations.stop("irradiate");
        super.burn();
    }
}
